(function () {
  const sectionSelector = '.video-testimonials';
  const youtubeSectionSelector = '.video-testimonials[data-has-youtube-iframes]';
  const MOBILE_QUERY = '(max-width: 989px)';
  let isYouTubeAPIReady = false;

  const players = {
    youtube: {},
    vimeo: [],
    html5: []
  };

  function getContainerMedia(container) {
    return {
      ytIframe: container.querySelector('iframe.js-video-testimonials-youtube'),
      vimeoIframe: container.querySelector('iframe.js-video-testimonials-vimeo'),
      html5Video: container.querySelector('video'),
      playBtn: container.querySelector('button.video-testimonials__play'),
      preview: container.querySelector('.video-testimonials__video--preview')
    };
  }

  function isIframeLoaded(iframe) {
    return Boolean(iframe && iframe.getAttribute('src'));
  }

  function loadIframe(iframe) {
    if (!iframe || isIframeLoaded(iframe)) return Promise.resolve();

    const src = iframe.dataset.src;
    if (!src) return Promise.resolve();

    return new Promise((resolve) => {
      iframe.addEventListener('load', () => resolve(), { once: true });
      iframe.src = src;
    });
  }

  function resetContainerUI(container) {
    const { playBtn, preview } = getContainerMedia(container);
    container.classList.remove('video-is-playing');
    if (playBtn) playBtn.style.display = '';
    if (preview) preview.style.display = '';
  }

  function unloadContainer(container) {
    if (!container) return;

    const { ytIframe, vimeoIframe, html5Video } = getContainerMedia(container);
    resetContainerUI(container);

    if (ytIframe) {
      const player = players.youtube[ytIframe.id];
      if (player) {
        try {
          if (typeof player.pauseVideo === 'function') player.pauseVideo();
          if (typeof player.stopVideo === 'function') player.stopVideo();
        } catch (e) {
          /* ignore */
        }
        delete players.youtube[ytIframe.id];
      }

      ytIframe.removeAttribute('src');
    }

    if (vimeoIframe) {
      try {
        if (isIframeLoaded(vimeoIframe)) {
          vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      } catch (e) {
        /* ignore */
      }
      vimeoIframe.removeAttribute('src');
    }

    if (html5Video) {
      html5Video.pause();
      html5Video.currentTime = 0;
    }
  }

  function unloadAllExcept(activeContainer) {
    document.querySelectorAll(`${sectionSelector} .video-testimonials__video`).forEach((container) => {
      if (container === activeContainer) return;
      if (!container.classList.contains('video-is-playing') && !isContainerLoaded(container)) return;
      unloadContainer(container);
    });
  }

  function isContainerLoaded(container) {
    const { ytIframe, vimeoIframe } = getContainerMedia(container);
    return isIframeLoaded(ytIframe) || isIframeLoaded(vimeoIframe);
  }

  function showPlayingUI(container) {
    const { playBtn, preview } = getContainerMedia(container);
    container.classList.add('video-is-playing');
    if (playBtn) playBtn.style.display = 'none';
    if (preview) preview.style.display = 'none';
  }

  function onPlayerStateChange(event) {
    const container = event.target.getIframe().closest('.video-testimonials__video');
    if (!container) return;

    if (event.data === YT.PlayerState.PLAYING) {
      unloadAllExcept(container);
      showPlayingUI(container);
      return;
    }

    container.classList.remove('video-is-playing');

    if (event.data === YT.PlayerState.ENDED) {
      unloadContainer(container);
    }
  }

  function initYoutubePlayer(iframe) {
    if (!iframe.id) {
      iframe.id = `video-testimonials-yt-${Math.random().toString(36).substring(7)}`;
    }

    if (players.youtube[iframe.id]) return players.youtube[iframe.id];

    if (typeof YT === 'undefined' || !YT.Player) return null;

    players.youtube[iframe.id] = new YT.Player(iframe.id, {
      events: {
        onStateChange: onPlayerStateChange
      }
    });

    return players.youtube[iframe.id];
  }

  function initYoutubePlayers() {
    document.querySelectorAll(`${youtubeSectionSelector} iframe.js-video-testimonials-youtube[src]`).forEach((iframe) => {
      initYoutubePlayer(iframe);
    });

    isYouTubeAPIReady = true;
  }

  const previousYouTubeReady = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function () {
    if (typeof previousYouTubeReady === 'function') {
      previousYouTubeReady();
    }

    initYoutubePlayers();
  };

  async function playYoutubeVideo(container, ytIframe) {
    unloadAllExcept(container);
    showPlayingUI(container);

    const wasLoaded = isIframeLoaded(ytIframe);
    await loadIframe(ytIframe);

    if (!wasLoaded) {
      await new Promise((resolve) => {
        if (typeof YT !== 'undefined' && YT.Player) {
          initYoutubePlayer(ytIframe);
          resolve();
          return;
        }

        let attempts = 0;
        const checkAPI = setInterval(() => {
          attempts += 1;
          if (typeof YT !== 'undefined' && YT.Player) {
            clearInterval(checkAPI);
            initYoutubePlayer(ytIframe);
            resolve();
          } else if (attempts > 50) {
            clearInterval(checkAPI);
            resolve();
          }
        }, 100);
      });
    } else if (typeof YT !== 'undefined' && YT.Player) {
      initYoutubePlayer(ytIframe);
    }

    const player = players.youtube[ytIframe.id];
    if (player && typeof player.playVideo === 'function') {
      player.playVideo();
    }
  }

  async function playVimeoVideo(container, vimeoIframe) {
    unloadAllExcept(container);
    showPlayingUI(container);

    const wasLoaded = isIframeLoaded(vimeoIframe);
    await loadIframe(vimeoIframe);

    if (wasLoaded) {
      try {
        vimeoIframe.contentWindow.postMessage('{"method":"play"}', '*');
      } catch (e) {
        /* ignore */
      }
    }
  }

  function playHtml5Video(container, html5Video) {
    unloadAllExcept(container);
    showPlayingUI(container);
    html5Video.play();
  }

  function initVideoTestimonialsCarousel(section) {
    if (!section || section.dataset.videoTestimonialsCarouselInit === 'true') return;

    const track = section.querySelector('[data-video-testimonials-track]');
    const prevBtn = section.querySelector('[data-video-testimonials-prev]');
    const nextBtn = section.querySelector('[data-video-testimonials-next]');
    const dots = Array.from(section.querySelectorAll('[data-video-testimonials-dot]'));
    const slides = track ? Array.from(section.querySelectorAll('[data-video-testimonials-slide]')) : [];

    if (!track || slides.length < 2) return;

    section.dataset.videoTestimonialsCarouselInit = 'true';

    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    let scrollRaf = null;

    function isMobile() {
      return mediaQuery.matches;
    }

    function isCarouselActive() {
      return isMobile() || section.classList.contains('video-testimonials--desktop-carousel');
    }

    function getStep() {
      const first = slides[0];
      const second = slides[1];
      if (second) return second.offsetLeft - first.offsetLeft;
      return first ? first.getBoundingClientRect().width : 0;
    }

    function getActiveIndex() {
      const step = getStep() || 1;
      const index = Math.round(track.scrollLeft / step);
      return Math.max(0, Math.min(slides.length - 1, index));
    }

    function updateControls() {
      if (!isCarouselActive()) return;

      const index = getActiveIndex();
      const maxScroll = track.scrollWidth - track.clientWidth;

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });

      if (prevBtn) prevBtn.disabled = index <= 0 && track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1 && track.scrollLeft >= maxScroll - 1;
    }

    function scrollToIndex(index) {
      const clamped = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: clamped * (getStep() || 0),
        behavior: 'smooth'
      });
    }

    function onPrev() {
      scrollToIndex(getActiveIndex() - 1);
    }

    function onNext() {
      scrollToIndex(getActiveIndex() + 1);
    }

    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(() => {
        scrollRaf = null;
        updateControls();
      });
    }

    function onKeydown(event) {
      if (!isCarouselActive() || event.target !== track) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        onPrev();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        onNext();
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number.parseInt(dot.dataset.videoTestimonialsDot || '0', 10);
        scrollToIndex(index);
      });
    });

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('keydown', onKeydown);

    const resizeObserver = new ResizeObserver(updateControls);
    resizeObserver.observe(track);
    slides.forEach((slide) => resizeObserver.observe(slide));

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateControls);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(updateControls);
    }

    updateControls();
  }

  function initSectionVideos(section) {
    if (!section || section.dataset.videoTestimonialsVideosInit === 'true') return;
    section.dataset.videoTestimonialsVideosInit = 'true';

    const videoContainers = section.querySelectorAll('.video-testimonials__video');

    videoContainers.forEach((container) => {
      const { ytIframe, vimeoIframe, html5Video, playBtn } = getContainerMedia(container);

      if (vimeoIframe) players.vimeo.push(vimeoIframe);
      if (html5Video) players.html5.push(html5Video);

      if (!playBtn || (!ytIframe && !vimeoIframe && !html5Video)) return;

      playBtn.addEventListener('click', () => {
        if (container.classList.contains('video-is-playing')) return;

        if (ytIframe) {
          playYoutubeVideo(container, ytIframe);
          return;
        }

        if (vimeoIframe) {
          playVimeoVideo(container, vimeoIframe);
          return;
        }

        if (html5Video) {
          playHtml5Video(container, html5Video);
        }
      });

      if (!html5Video) return;

      html5Video.addEventListener('play', () => {
        unloadAllExcept(container);
        showPlayingUI(container);
      });

      html5Video.addEventListener('pause', () => {
        if (html5Video.ended) return;
        container.classList.remove('video-is-playing');
      });

      html5Video.addEventListener('ended', () => {
        resetContainerUI(container);
      });
    });
  }

  function initVideoTestimonials() {
    const sections = document.querySelectorAll(sectionSelector);
    if (!sections.length) return;

    sections.forEach((section) => {
      initVideoTestimonialsCarousel(section);
      initSectionVideos(section);
    });

    if (typeof YT !== 'undefined' && YT.Player) {
      initYoutubePlayers();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoTestimonials);
  } else {
    initVideoTestimonials();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector(sectionSelector);
    if (!section) return;
    initVideoTestimonialsCarousel(section);
    initSectionVideos(section);
  });
})();
